import { NODE_TYPES } from '@services/conditionEngine/constants';
import evaluatorRegistry from '@services/conditionEngine/evaluators/registry';

const falseEvaluator = () => false;

evaluatorRegistry.registerEvaluatorForNodeType(NODE_TYPES.FALSE, falseEvaluator);
export default falseEvaluator;
